'use client';

import React from 'react';
import NewTournamentContent from '@/app/dashboard/tournament/list/components/new-tournament-content';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';

import { GeneralDrawer } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function NewTournamentDrawer(): React.JSX.Element | null {
  const { drawerState } = useAppSelector(getUi);

  const dispatch = useAppDispatch();

  return (
    <DrawerTemplate
      open={drawerState.NEW_TOURNAMENT}
      onClose={() => {
        dispatch(hideDrawerState(GeneralDrawer.NEW_TOURNAMENT));
      }}
      title="New Tournament"
      width="830px"
    >
      <NewTournamentContent />
    </DrawerTemplate>
  );
}
